import { createReducer, on } from '@ngrx/store';

import { UPSELLING_STORE_API_ACTIONS } from './upselling.action';
import { UPSELLING_STORE_INITIAL_STATE, UpsellingState } from './upselling.state';

export const UPSELLING_STORE_REDUCER = createReducer(
  UPSELLING_STORE_INITIAL_STATE,

  // API Actions
  on(UPSELLING_STORE_API_ACTIONS.loadUpselling, (state): UpsellingState => ({
    ...state,
    isLoading: true,
    hasError: false,
    error: null,
  })),

  on(UPSELLING_STORE_API_ACTIONS.loadUpsellingSuccess, (state, { data }): UpsellingState => ({
    ...state,
    data,
    isLoading: false,
    isLoaded: true,
    hasError: false,
    error: null,
  })),

  on(UPSELLING_STORE_API_ACTIONS.loadUpsellingFailure, (state, { error }): UpsellingState => ({
    ...state,
    isLoading: false,
    hasError: true,
    error,
  })),

  on(UPSELLING_STORE_API_ACTIONS.loadUpsellingComplete, (state): UpsellingState => ({
    ...state,
    isLoading: false,
  })),
);
